import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Row, Col, Alert, message } from "antd";
import { confirmPasswordRules, passwordRules } from "../../../helpers/helpers";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import CustomButton from "../../../components/CustomButton/Button";
import CustomInput from "../../../components/CustomInput/Input";
import { changePassword } from "../../../redux/slices/BusinessProfileSlice";
import ProfileSectionLayout from "../../../components/ProfileSectionLayout/ProfileSectionLayout";
import { BTN_TXT, ERROR_MSGS, TITLE_TXT } from "../../../constants/constants";
import CryptoJS from "crypto-js";

const ChangePassword = () => {
  const dispatch = useDispatch();
  const { passChangeLoading, passChangeError } = useSelector(
    (state) => state.profile1,
  );
  const [visible, setVisible] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [form] = Form.useForm();

  const toggleVisibility = () => {
    setVisible(!visible);
  };

  const handleSubmit = async (values) => {
    const oldhHashedPassword = CryptoJS.SHA256(
      values.currentPassword,
    ).toString();
    const newHashedPassword = CryptoJS.SHA256(values.enterPassword).toString();
    const confirmHashedPassword = CryptoJS.SHA256(
      values.confirmPassword,
    ).toString();

    const payload = {
      oldPassword: oldhHashedPassword,
      newPassword: newHashedPassword,
      confirmPassword: confirmHashedPassword,
    };
    const res = await dispatch(changePassword(payload));
    if (res.payload.statusCode === 201) {
      message.success("Password changed successfully! Please login again.", 2);
      form.resetFields();
      localStorage.clear();
      setTimeout(() => {
        window.location.href = "/login";
      }, 2000);
    }
  };

  const handleFieldsChange = () => {
    setIsButtonDisabled(
      !form.isFieldsTouched(true) ||
        form.getFieldsError().some(({ errors }) => errors.length),
    );
  };

  return (
    <ProfileSectionLayout title={TITLE_TXT.CHNG_PWD_TITLE}>
      <Form
        layout="vertical"
        onFinish={handleSubmit}
        form={form}
        onFieldsChange={handleFieldsChange}
        initialValues={{ remember: true }}
        className="change-password-form"
      >
        <Row>
          <Col xs={24} md={18} lg={12}>
            <CustomInput
              label="Enter Current Password"
              name="currentPassword"
              type={visible ? "text" : "password"}
              isPassword={true}
              iconRender={(visible) =>
                visible ? (
                  <EyeInvisibleOutlined onClick={toggleVisibility} />
                ) : (
                  <EyeOutlined onClick={toggleVisibility} />
                )
              }
              placeholder="Current password"
              rules={[
                { required: true, message: ERROR_MSGS.ENTER_CURR_PWD_ERR_MSG },
              ]}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={18} lg={12}>
            <CustomInput
              label="Enter New Password"
              name="enterPassword"
              type={visible ? "text" : "password"}
              isPassword={true}
              iconRender={(visible) =>
                visible ? (
                  <EyeInvisibleOutlined onClick={toggleVisibility} />
                ) : (
                  <EyeOutlined onClick={toggleVisibility} />
                )
              }
              placeholder="Enter Password"
              rules={passwordRules}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={18} lg={12}>
            <CustomInput
              label="Confirm New Password"
              name="confirmPassword"
              type={visible ? "text" : "password"}
              isPassword={true}
              iconRender={(visible) =>
                visible ? (
                  <EyeInvisibleOutlined onClick={toggleVisibility} />
                ) : (
                  <EyeOutlined onClick={toggleVisibility} />
                )
              }
              placeholder="Re-enter Password"
              rules={confirmPasswordRules}
            />
          </Col>
        </Row>
        {passChangeError && (
          <Row>
            <Col xs={24} md={18} lg={12}>
              <Alert
                style={{ marginBottom: 20 }}
                message={passChangeError}
                type="error"
                showIcon
              />
            </Col>
          </Row>
        )}
        <Row>
          <Col xs={24} md={18} lg={12}>
            <CustomButton
              type="primary"
              htmlType="submit"
              loading={passChangeLoading}
              block
              disabled={isButtonDisabled}
            >
              {BTN_TXT.CHNG_PWD}
            </CustomButton>
          </Col>
        </Row>
      </Form>
    </ProfileSectionLayout>
  );
};

export default ChangePassword;
